export const COMPANY_SETTINGS_PATH = "/settings-menu/company-settings";
